import { NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';

export const presentationOptions: NgbModalOptions = {
  backdropClass: `fixed inset-0 h-screen w-screen bg-black bg-opacity-40 animate-fade-in z-modal-backdrop`,
  windowClass: `fixed z-modal-window h-screen w-screen`,
  modalDialogClass: `h-full flex flex-row-reverse transform animate-slide-in`,
};

export const centeredPresentationOptions: NgbModalOptions = {
  backdropClass: `fixed inset-0 h-screen w-screen bg-black bg-opacity-10 backdrop-filter backdrop-blur animate-fade-in z-modal-backdrop`,
  windowClass: `fixed z-modal-window h-screen w-screen flex items-center justify-center overflow-y-auto`,
  modalDialogClass: ``,
};
